export const answerInput = { cy: 'answer-input' };
export const answerCheckbox = { cy: 'answer-checkbox' };
